import './App.css';
import Navbar from './components/Navbar.jsx';
import { Footer } from './components/Sections.jsx';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home.jsx';
import About from './pages/About.jsx';
import ServicesPage from './pages/Services.jsx';
import MarketsPage from './pages/Markets.jsx';
import OfferingsPage from './pages/Offerings.jsx';
import TestimonialsPage from './pages/Testimonials.jsx';
import ContactPage from './pages/Contact.jsx';
import WealthManagement from './pages/WealthManagement.jsx';
import FinancialPlanning from './pages/FinancialPlanning.jsx';
import RetirementPlanning from './pages/RetirementPlanning.jsx';
import ManagedPortfolios from './pages/ManagedPortfolios.jsx';
import WealthEstatePlanning from './pages/WealthEstatePlanning.jsx';
import MutualFunds from './pages/MutualFunds.jsx';
import InvestmentManagement from './pages/InvestmentManagement.jsx';
import PersonalRetirementAccount from './pages/PersonalRetirementAccount.jsx';
import SecuritiesTradingBrokerage from './pages/SecuritiesTradingBrokerage.jsx';
import TrusteeRegistrarServices from './pages/TrusteeRegistrarServices.jsx';
import Careers from './pages/Careers.jsx';
import InstitutionalServices from './pages/InstitutionalServices.jsx';
import ResearchAnalytics from './pages/ResearchAnalytics.jsx';
import InvestmentsHealthcare from './pages/InvestmentsHealthcare.jsx';
import InvestmentsDigitalAssets from './pages/InvestmentsDigitalAssets.jsx';
import InvestmentsAgriculture from './pages/InvestmentsAgriculture.jsx';
import InvestmentsTechnology from './pages/InvestmentsTechnology.jsx';
import InvestmentsServices from './pages/InvestmentsServices.jsx';
import InvestmentsIndustrialTechnology from './pages/InvestmentsIndustrialTechnology.jsx';
import InvestmentsRealEstate from './pages/InvestmentsRealEstate.jsx';
import PortfolioManagement from './pages/PortfolioManagement.jsx';
import RiskManagement from './pages/RiskManagement.jsx';
import Privacy from './pages/Privacy.jsx';
import Terms from './pages/Terms.jsx';
import RiskDisclosure from './pages/RiskDisclosure.jsx';
import ApplyNow from './pages/ApplyNow.jsx';
import LiveChatWidget from './components/LiveChatWidget.jsx';
import { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Preloader from './components/Preloader.jsx';

function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  }, [location.pathname]);
  return null;
}

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false,
      offset: 100
    });
  }, []);

  useEffect(() => {
    let isMounted = true;

    const assetsToPreload = [
      '/new-assets/pexels-vlada-karpovich-7433824.jpg'
    ];

    const preloadImage = (src) =>
      new Promise((resolve) => {
        const img = new Image();
        img.onload = resolve;
        img.onerror = resolve;
        img.src = src;
      });

    const waitForWindowLoad =
      document.readyState === 'complete'
        ? Promise.resolve()
        : new Promise((resolve) => window.addEventListener('load', resolve, { once: true }));

    Promise.all([waitForWindowLoad, ...assetsToPreload.map(preloadImage)]).then(() => {
      if (isMounted) {
        setIsLoading(false);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = isLoading ? 'hidden' : '';
    }
    return () => {
      if (typeof document !== 'undefined') {
        document.body.style.overflow = '';
      }
    };
  }, [isLoading]);

  return (
    <div className="App relative">
      <Preloader isLoading={isLoading} />
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/markets" element={<MarketsPage />} />
        <Route path="/offerings" element={<OfferingsPage />} />
        <Route path="/testimonials" element={<TestimonialsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/portfolio-management" element={<PortfolioManagement />} />
        <Route path="/financial-planning" element={<FinancialPlanning />} />
        <Route path="/risk-management" element={<RiskManagement />} />
        <Route path="/wealth-management" element={<WealthManagement />} />
        <Route path="/retirement-planning" element={<RetirementPlanning />} />
        <Route path="/managed-portfolios" element={<ManagedPortfolios />} />
        <Route path="/wealth-estate-planning" element={<WealthEstatePlanning />} />
        <Route path="/mutual-funds" element={<MutualFunds />} />
        <Route path="/investment-management" element={<InvestmentManagement />} />
        <Route path="/personal-retirement-account" element={<PersonalRetirementAccount />} />
        <Route path="/securities-trading-brokerage" element={<SecuritiesTradingBrokerage />} />
        <Route path="/trustee-registrar-services" element={<TrusteeRegistrarServices />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/institutional-services" element={<InstitutionalServices />} />
        <Route path="/research-analytics" element={<ResearchAnalytics />} />
        <Route path="/investments/healthcare" element={<InvestmentsHealthcare />} />
        <Route path="/investments/digital-assets" element={<InvestmentsDigitalAssets />} />
        <Route path="/investments/agriculture" element={<InvestmentsAgriculture />} />
        <Route path="/investments/real-estate" element={<InvestmentsRealEstate />} />
        <Route path="/investments/technology" element={<InvestmentsTechnology />} />
        <Route path="/investments/services" element={<InvestmentsServices />} />
        <Route path="/investments/industrial-technology" element={<InvestmentsIndustrialTechnology />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/risk-disclosure" element={<RiskDisclosure />} />
        <Route path="/apply" element={<ApplyNow />} />
      </Routes>
      {/* Keep footer on all pages */}
      <Footer />
      <LiveChatWidget />
    </div>
  );
}

export default App;
